<template>
  <div class="footer-template">서울시 송파구 충민로 66 테크노관 10층 T-10017 전화. 02-2157-1114 <br>
    송파구시설관리공단  대표자 : 황대성 고유번호 : 215-82-06107<br>
    COPYRIGHT(C)2012 SONGPAGU FACILITIES MANAGEMENT CORPORATION ALL RIGHT RESERVED. </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

.footer-template {
  display: flex;
  justify-content: center;
  font: 14px/24px NotoSansKR-Medium;
  color: #fff;
  background-color: #304156;
  padding: 10px 0 10px 0;
}

</style>
